/**
 * Podcast Episodes Section - Public Exports
 * Barrel export for easy importing in other components
 */

export { PodcastIcon } from "./PodcastIcon";
export { PodcastCard } from "./PodcastCard";
export { PodcastEpisodeColumn } from "./PodcastEpisodeColumn";
export { PodcastEpisodesSection } from "./PodcastEpisodesSection";

// Type exports
export type { PodcastEpisode } from "./types";
export type { PodcastIconProps } from "./types";
export type { PodcastCardProps } from "./types";
export type { PodcastEpisodeColumnProps } from "./types";
export type { PodcastEpisodesSectionProps } from "./types";
export type { PodcastSectionData } from "./types";
export type { DatoCMSPodcastEpisode } from "./types";
export type { DatoCMSPodcastSection } from "./types";

// Constant and utility exports
export {
  PODCAST_COLUMNS,
  COLUMN_LABELS,
  ICON_SIZES,
  SPACING,
  isPodcastColumnType,
} from "./constants";

// Fetcher and transformation exports
export {
  transformDatoCMSPodcastEpisode,
  transformDatoCMSPodcastSection,
  PODCAST_EPISODE_FRAGMENT,
  HOMEPAGE_PODCAST_QUERY,
} from "./fetcher";
